import Control from 'ol/control/Control';
import { minPoints, minLoad } from './state.js';

export class RotateNorthControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const { onMinPoints, onMinLoad, onFilterProblems } = options;

    // --- toggle button (always visible) ---
    const toggle = document.createElement('button');
    toggle.className = 'filter-toggle';
    toggle.innerHTML = '&#9776;';
    toggle.title = 'Filter';

    // --- popup panel (closed by default via CSS class) ---
    const panel = document.createElement('div');
    panel.className = 'filter-panel filter-panel--closed';
    panel.innerHTML = `
      <div class="filter-group">
        <span class="filter-label">Min points</span>
        <div class="filter-row">
          <button data-pts="4">4</button>
          <button data-pts="6">6</button>
          <button data-pts="8">8</button>
          <button data-pts="12">12</button>
        </div>
      </div>
      <div class="filter-group">
        <span class="filter-label">Min kW</span>
        <div class="filter-row">
          <button data-kw="50">50</button>
          <button data-kw="100">100</button>
          <button data-kw="120">120</button>
          <button data-kw="150">150</button>
        </div>
      </div>
      <div class="filter-group">
        <label class="filter-toggle-row">
          <input type="checkbox" data-action="filter-problems" ${options.filterProblems ? 'checked' : ''} />
          Hide stations with problems
        </label>
      </div>
      <div class="filter-group">
        <div class="filter-row">
          <button data-action="north">&#8593; Reset North</button>
        </div>
      </div>
    `;

    const element = document.createElement('div');
    element.className = 'filter-control ol-unselectable ol-control';
    element.append(toggle, panel);

    // prevent clicks inside the control from bubbling to the map
    element.addEventListener('click', e => e.stopPropagation());

    super({ element, target: options.target });

    const close = () => panel.classList.add('filter-panel--closed');

    const refreshActive = () => {
      panel.querySelectorAll('[data-pts]').forEach(btn => {
        btn.classList.toggle('filter-btn--active', parseInt(btn.dataset.pts, 10) === minPoints);
      });
      panel.querySelectorAll('[data-kw]').forEach(btn => {
        btn.classList.toggle('filter-btn--active', parseInt(btn.dataset.kw, 10) === minLoad);
      });
    };

    toggle.addEventListener('click', () => {
      const isOpen = !panel.classList.contains('filter-panel--closed');
      if (isOpen) {
        close();
      } else {
        refreshActive();
        panel.classList.remove('filter-panel--closed');
      }
    });

    panel.querySelector('[data-action="filter-problems"]').addEventListener('change', (e) => {
      onFilterProblems(e.target.checked);
    });

    panel.querySelector('[data-action="north"]').addEventListener('click', () => {
      this.getMap().getView().setRotation(0);
      close();
    });

    panel.querySelectorAll('[data-pts]').forEach(btn => {
      btn.addEventListener('click', () => { onMinPoints(parseInt(btn.dataset.pts, 10)); close(); });
    });

    panel.querySelectorAll('[data-kw]').forEach(btn => {
      btn.addEventListener('click', () => { onMinLoad(parseInt(btn.dataset.kw, 10)); close(); });
    });
  }

  setMap(map) {
    super.setMap(map);
    if (map) {
      map.on('click', () => {
        this.element.querySelector('.filter-panel').classList.add('filter-panel--closed');
      });
    }
  }
}
